import { useApp } from '@context/AppContext';
import { Crown, X } from 'lucide-react';

export default function MembersPanel() {
  const { state, dispatch } = useApp();
  const { room, user, ui } = state;

  if (!ui.membersOpen) return null;

  const members = Object.entries(room.members || {}).sort(
    ([, a], [, b]) => a.joinedAt - b.joinedAt
  );

  return (
    <div className="w-60 bg-white border-l border-slate-100 flex flex-col shrink-0 animate-slide-in-right">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
        <h3 className="text-sm font-semibold text-charcoal font-display">
          Members ({members.length}/10)
        </h3>
        <button
          onClick={() => dispatch({ type: 'TOGGLE_MEMBERS' })}
          className="w-7 h-7 flex items-center justify-center rounded-lg text-slate-400 hover:text-charcoal hover:bg-slate-100 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Member list */}
      <div className="flex-1 overflow-y-auto p-2">
        {members.map(([id, member]) => (
          <div
            key={id}
            className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50"
          >
            <div
              className="w-3 h-3 rounded-full shrink-0"
              style={{ backgroundColor: member.colour }}
            />
            <span className="text-sm text-charcoal font-display truncate flex-1">
              {member.nickname}
            </span>
            {id === user.id && (
              <span className="text-[10px] text-slate-400 font-mono">you</span>
            )}
            {member.isHost && (
              <Crown className="w-3.5 h-3.5 text-amber shrink-0" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
